var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-div"},[_c('van-loading',{attrs:{"vertical":"","size":"30px"}},[_vm._v("加载中...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }